//通过国家列表，显示对应的文件上传个数
const getUploadFileByCountry=(currCountry)=>{
  let CountryList = {
    ALB: "2+1",
    AND: "1+1",
    ARE: "2+1",
    ARG: "2+1",
    ARM: "2+1",
    AUS: "",
    AUT: "1+1",
    AZE: "2+1",
    BEL: "",
    BEN: "2+1",
    BFA: "2+1",
    BGD: "2+1",
    BLR: "2+1",
    BGR: "2+1",
    BHR: "2+1",
    BOL: "2+1",
    BRA: "2+1",
    BWA: "2+1",
    CHE: "2+1",
    CHL: "2+1",
    CHN: "1+1",
    COL: "2+1",
    CPV: "2+1",
    CRI: "2+1",
    CIV: "2+1",
    CYP: "1+1",
    CZE: "1+1",
    DEU: "1+1",
    DMA: "2+1",
    DNK: "1+1",
    DOM: "2+1",
    EGY: "2+1",
    ESP: "1+1",
    EST: "1+1",
    FIN: "1+1",
    FRA: "",
    GBR: "1+1",
    GEO: "2+1",
    GHA: "2+1",
    GIB: "2+1",
    GNB: "",
    GRC: "1+1",
    GRD: "2+1",
    GTM: "2+1",
    HND: "2+1",
    HRV: "1+1",
    HTI: "2+1",
    HUN: "1+1",
    IDN: "2+1",
    IND: "2+1",
    IRL: "1+1",
    ISL: "1+1",
    ISR: "2+1",
    ITA: "1+1",
    JAM: "2+1",
    JOR: "2+1",
    JPN: "2+1",
    KAZ: "2+1",
    KEN: "2+1",
    KGZ: "2+1",
    KHM: "2+1",
    KOR: "2+1",
    KWT: "2+1",
    LIE: "2+1",
    LBR: "",
    LCA: "2+1",
    LSO: "2+1",
    LTU: "1+1",
    LUX: "1+1",
    LVA: "1+1",
    MAR: "2+1",
    MCO: "2+1",
    MDA: "2+1",
    MEX: "2+1",
    MHL: "2+1",
    MLI: "",
    MLT: "1+1",
    MNE: "2+1",
    MNG: "2+1",
    MOZ: "2+2",
    MUS: "2+1",
    MWI: "2+1",
    MYS: "2+1",
    NAM: "2+1",
    NER: "2+2",
    NGA: "2+1",
    NIC: "2+1",
    NLD: "1+1",
    NOR: "1+1",
    NZL: "",
    OMN: "2+1",
    PAK: "2+1",
    PER: "2+1",
    PHL: "2+1",
    POL: "1+1",
    PRT: "1+1",
    PRY: "2+1",
    QAT: "2+1",
    ROU: "2+1",
    RUS: "2+1",
    RWA: "2+1",
    SMR: "1+1",
    SAU: "2+1",
    SEN: "2+1",
    SGP: "",
    SLE: "",
    SLV: "2+1",
    SRB: "2+1",
    SVK: "1+1",
    SVN: "1+1",
    SWE: "1+1",
    THA: "2+1",
    TLS: "2+1",
    TJK: "2+2",
    TTO: "2+1",
    TUN: "2+1",
    TUR: "2+1",
    TWN: "1+1",
    TZA: "2+1",
    UKR: "2+1",
    URY: "2+1",
    UZB: "2+1",
    VCT: "2+1",
    VEN: "",
    VNM: "2+1",
    VUT: "2+2",
    ZAF: "2+1",
    ZMB: "2+2",
    DZA:"2+1",
    AGO:"2+1",
    BIH:"2+1",
    GMB:"2+1",
    GUY:"2+1",
    IRQ:"2+1",
    RKS:"2+1",
    LBN:"2+1",
    NPL:"2+1",
    PAN:"2+1",
    PNG:"2+1",
    LKA:"2+1",
    MKD:"1+1"
  }
  const uploadFiles1 = ['Proof_of_Address','Proof_of_Address_2'];
  const uploadFiles2 = ['Doc_Front_Img','Doc_Back_Img'];
  
  let type;
  if(currCountry in CountryList){
    if(CountryList[currCountry]) type = CountryList[currCountry];
    else type = '2+2';
  }else type = '2+2';

  let arr = ['Other_Files'];
  let result = type.split('+');
  if(result[0]==1){
    arr.unshift(uploadFiles1[0]);
  }else if(result[0]==2){
    arr.unshift(...uploadFiles1);
  }

  if(result[1]==1){
    arr.unshift(uploadFiles2[0]);
  }else if(result[1]==2){
    arr.unshift(...uploadFiles2);
  }
  return arr;
}
module.exports = getUploadFileByCountry;


// WEBPACK FOOTER //
// ./src/assets/js/getUploadFileByCountry.js